<div class="chart">
  <canvas class="canvas" baseChart [datasets]="mixedChartData" [labels]="mixedChartLabels" [options]="mixedChartOptions"
    [legend]="true">
  </canvas>
</div>
